<!-- Show unauthorized page when login fails -->
<app-unauthorized 
  *ngIf="loginFailed && !isAuthLoading"
  [message]="loginErrorMessage"
  [errorDetails]="loginErrorDetails"
  (loginClick)="login()"
  (retryClick)="retryLogin()">
</app-unauthorized>

<!-- Show main app when authenticated -->
<app-navigation *ngIf="!isAuthLoading && !loginFailed"></app-navigation>

<!-- Show loading screen during authentication -->
<app-auth-loading 
  [isLoading]="isAuthLoading" 
  title="Authenticating" 
  [message]="authLoadingMessage">
</app-auth-loading>

